import React, { PropsWithChildren } from 'react';

import { Navigation } from 'pages/Bulletin/constants';

interface Props {
    hidden?: boolean;
    className?: string;
    value: Navigation;
}

const NavigationItem: React.ForwardRefRenderFunction<HTMLDivElement, PropsWithChildren<Props>> = (
    { hidden, className, value, children },
    ref
) => {
    return hidden ? null : (
        <div ref={ref} data-navigation={value} className={className}>
            {children}
        </div>
    );
};

export default React.forwardRef(NavigationItem);
